<section class="audience" aria-labelledby="audience-title">
  <div class="audience__inner">
    <p class="audience__eyebrow">Built for the ecosystem</p>

    <h2 id="audience-title" class="audience__title">Who is BODH for?</h2>
  </div>

  <ul class="audience__cards">
    <li class="audience__card">
      <span class="audience__card-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <circle cx="10.8" cy="10.8" r="6.3" stroke="currentColor" stroke-width="1.8" />
          <path d="m15.5 15.5 4 4" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" />
        </svg>
      </span>
      <h3 class="audience__card-title">Researchers</h3>
      <p class="audience__card-text">
        Benchmark new AI techniques and support research with trusted evaluation.
      </p>
    </li>

    <li class="audience__card">
      <span class="audience__card-icon" aria-hidden="true">
        <img
          class="audience__card-icon-img"
          src="/landing/icon-ai-developer.png"
          alt=""
          width="24"
          height="24"
        />
      </span>
      <h3 class="audience__card-title">AI developers</h3>
      <p class="audience__card-text">
        Validate model performance using benchmarking datasets built for the Indian healthcare
        context.
      </p>
    </li>

    <li class="audience__card">
      <span class="audience__card-icon" aria-hidden="true">
        <svg viewBox="0 0 24 24" fill="none">
          <circle cx="9" cy="8.5" r="3.3" stroke="currentColor" stroke-width="1.8" />
          <path
            d="M3.5 19c0-3 2.5-4.8 5.5-4.8s5.5 1.8 5.5 4.8"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
          />
          <path
            d="M16 6.2a3 3 0 0 1 0 5.6M17.5 18.4c0-2.3-.9-3.9-2.4-4.9"
            stroke="currentColor"
            stroke-width="1.8"
            stroke-linecap="round"
          />
        </svg>
      </span>
      <h3 class="audience__card-title">Healthcare AI organizations</h3>
      <p class="audience__card-text">
        Assess AI models against representative benchmarking datasets before deployment.
      </p>
    </li>
  </ul>
</section>
